import React from 'react';
import { HeaderTemplate, Stepper, TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import ConfirmAmendmentDetails from '../../modules/subject/components/ConfirmAmendmentDetails';
import ExamTypeUuidDisplay from '../../modules/examRegistration/components/ExamTypeUuidDisplay';

interface ConfirmAmendmentDetailsPageProps {
  routeSteps: { label: string }[];
  isGroup?: boolean;
}

const ConfirmAmendmentDetailsPage = ({
  routeSteps,
  isGroup = false,
}: ConfirmAmendmentDetailsPageProps) => {
  const { t } = useTranslation();
  const title: string = isGroup
    ? t('amendment->>GroupSubjectAmendment.NewSubjectAmendment')
    : t('amendment->>SubjectAmendment.Subject Amendment');
  const activeStep = isGroup ? 5 : 4;
  return (
    <>
      <TitleHeader title={title} />
      <HeaderTemplate>
        {isGroup && <ExamTypeUuidDisplay />}
        <Stepper activeStep={activeStep} steps={routeSteps} />
      </HeaderTemplate>
      <ConfirmAmendmentDetails isGroup={isGroup} />
    </>
  );
};

export default ConfirmAmendmentDetailsPage;
